export function getWelcomeGuru(
  isDefaultTheme: boolean,
): { assetUrl: string, isLottieAnimation: boolean } {
  if (!isDefaultTheme) {
    return {
      assetUrl: 'welcome-widget-guru',
      isLottieAnimation: false,
    };
  }

  return {
    assetUrl: 'conveyer-belt.json',
    isLottieAnimation: true,
  };
}

export type WelcomeGuru = ReturnType<typeof getWelcomeGuru>;
